import { createContext, useContext } from 'react';

import type { Modifier } from '@popperjs/core';

export type WindowedDialogTooltipConfig = {
  zIndex: number;
  boundaryElement: HTMLElement | null;
};

export const WindowedTooltipZIndexContext = createContext<
  WindowedDialogTooltipConfig | undefined
>(undefined);

export const useWindowedTooltipZIndex = () =>
  useContext(WindowedTooltipZIndexContext);

type PopperSlotProps = {
  sx?: object;
  modifiers?: Partial<Modifier<string, Record<string, unknown>>>[];
  [key: string]: unknown;
};

export function withWindowedPopperProps(
  config: WindowedDialogTooltipConfig | undefined,
  popper?: PopperSlotProps
): PopperSlotProps | undefined {
  if (config === undefined) return popper;

  return {
    ...popper,
    sx: { zIndex: config.zIndex, ...popper?.sx },
    modifiers: [
      ...(config.boundaryElement
        ? [
            {
              name: 'preventOverflow',
              options: { boundary: config.boundaryElement },
            },
            { name: 'flip', options: { boundary: config.boundaryElement } },
          ]
        : []),
      ...(popper?.modifiers ?? []),
    ],
  };
}

export function withWindowedMenuProps<T extends Record<string, any>>(
  config: WindowedDialogTooltipConfig | undefined,
  menuProps?: T
): T | undefined {
  if (config === undefined) return menuProps;

  return {
    ...menuProps,
    slotProps: {
      ...menuProps?.slotProps,
      root: {
        ...menuProps?.slotProps?.root,
        sx: { zIndex: config.zIndex, ...menuProps?.slotProps?.root?.sx },
      },
    },
  } as unknown as T;
}
